import React, { FC } from "react";

type Props = {
  size: string;
  color: string;
  isEvaluated: boolean;
};

const Icon: FC<Props> = ({ size, color, isEvaluated }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 175 175"
      fill="none"
    >
      <g clipPath="url(#clip0_3404_2179)">
        <path
          d="M7.94626 75.6902C7.56605 70.8302 11.2065 66.6602 15.8356 66.6602L30.9868 66.6602C35.3592 66.6602 38.9047 70.3902 38.9047 74.9902L38.9046 158.33C38.9046 162.93 35.3592 166.66 30.9868 166.66L22.4321 166.66C18.3164 166.66 14.885 163.34 14.5428 159.02L7.94626 75.6902Z"
          fill={isEvaluated ? color : "none"}
        />
        <path
          d="M30.9964 58.33L15.8451 58.33C11.4252 58.33 7.17638 60.29 4.19175 63.71C1.20712 67.13 -0.313712 71.75 0.0569894 76.38L6.65357 159.72C7.33795 168.29 14.2672 175 22.4417 175L30.9964 175C39.7316 175 46.8415 167.52 46.8415 158.33L46.8415 75C46.8415 65.81 39.7316 58.33 30.9964 58.33ZM15.8451 75L15.8451 74.99L30.9964 74.99L30.9964 158.34L22.4417 158.34L15.8451 75.01L15.8451 75Z"
          fill={color}
        />
        <path
          d="M62.6772 76.5602C62.6772 73.0801 64.7304 69.9602 67.7245 68.4802C74.2546 65.2402 85.3756 58.7302 90.3944 49.9202C96.8579 38.5702 98.0841 18.0702 98.2837 13.3702C98.3122 12.7102 98.2932 12.0501 98.3787 11.4002C99.4528 3.27015 114.376 12.7702 120.098 22.8102C123.206 28.2602 123.606 35.4302 123.273 41.0202C122.921 47.0002 121.258 52.7902 119.623 58.5302L116.134 70.7602L159.136 70.7602C164.392 70.7602 168.185 76.0402 166.759 81.3602L145.486 160.59C144.526 164.18 141.409 166.66 137.863 166.66L70.5855 166.66C66.2132 166.66 62.6677 162.93 62.6677 158.33L62.6677 76.5602L62.6772 76.5602Z"
          fill={isEvaluated ? color : "none"}
        />
        <path
          d="M101.687 8.20333e-06C100.86 8.05875e-06 100.042 0.0800097 99.2247 0.250008C94.5482 1.25001 91.2213 5.08001 90.5465 10.25C90.4229 11.18 90.4039 11.99 90.3944 12.58L90.3944 13C89.9476 23.34 87.9135 38.1 83.6172 45.63C80.7086 50.73 73.6938 56.31 64.3597 60.94C58.533 63.83 54.7689 69.96 54.7689 76.56L54.7689 158.33C54.7689 167.52 61.8788 175 70.6141 175L137.892 175C144.954 175 151.218 170.01 153.138 162.86L174.411 83.63C175.77 78.56 174.819 73.24 171.797 69.04C168.774 64.84 164.174 62.43 159.164 62.43L126.809 62.43L127.313 60.65C129.033 54.62 130.81 48.38 131.21 41.53C131.751 32.22 130.307 24.48 126.923 18.52C124.242 13.82 119.946 9.07 115.136 5.48001C111.619 2.86001 106.639 -0.00998544 101.706 -0.0099863L101.687 8.20333e-06ZM70.6046 158.33L70.6046 76.56C70.6046 76.48 70.7567 76.19 71.1084 76.02C79.7961 71.71 91.3734 64.43 97.2001 54.21C103.065 43.92 105.146 28.12 105.878 19.05C108.492 21 111.515 23.95 113.321 27.11C114.984 30.03 115.726 34.8 115.384 40.52C115.098 45.45 113.654 50.52 112.123 55.88L108.559 68.38C107.836 70.9 108.293 73.64 109.794 75.75C111.287 77.86 113.644 79.11 116.153 79.11L159.155 79.11L137.882 158.34L70.6046 158.34L70.6046 158.33Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_3404_2179">
          <rect
            width="175"
            height="175"
            fill="white"
            transform="matrix(1 1.74846e-07 1.74846e-07 -1 0 175)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Icon;
